/**
 * The FaqAutocompleteSearch component
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import faqsActions from '../../redux/faqs';
import { bindActionCreators } from 'redux'
import { push } from 'connected-react-router'
import { ListGroup, ListGroupItem, InputGroup, Input } from 'reactstrap';
import { connect } from "react-redux";

/**
 * Stateless react component to render the FaqAutocompleteSearch page
 * @param {Object} props the props passed to the page.
 */

const mapStateToProps = state => ({
  faqsearchresults: state.faqs.search,
  language: state.i18nState.lang
})

/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = dispatch => bindActionCreators({
    searchFaqs: faqsActions.search,
    navigateTo: push
  },
  dispatch
)

class FaqAutocompleteSearch extends Component {
  constructor(props) {
    super(props);
    this.faqSearchInput = React.createRef();
    this.performFaqSearch = this.performFaqSearch.bind(this)
    this.handleFaqSearchClick = this.handleFaqSearchClick.bind(this)
    this.state = {
      faqSearchResultsOpen: false
    };
  }
  
  /** navigates to the show faqcategory page if user has permission */
  handleFaqSearchClick(faq) {
    const {navigateTo} = this.props;
    this.setState({ faqSearchResultsOpen: false });
    navigateTo(`/${ faq.language}/faq/${ faq.slug}/`)
  }

  performFaqSearch(e) {
    const { searchFaqs } = this.props;
    e.preventDefault();
    if (this.faqSearchInput.current.value.length > 3) {
      searchFaqs({q: this.faqSearchInput.current.value})
      this.setState({
        faqSearchResultsOpen: true
      });
    }
  }

  handleBlur(e) {
    e.preventDefault();
    setTimeout(() => this.setState({ faqSearchResultsOpen: false }), 500);
  }

  handleFocus(e) {
    e.preventDefault();
    this.setState({ faqSearchResultsOpen: true });
  }


  render() {
    const { faqsearchresults } = this.props;
    const { faqSearchResultsOpen } = this.state;
    return (
      <>
        <InputGroup>
          <Input innerRef={this.faqSearchInput} onChange={ this.performFaqSearch } onBlur={ this.handleBlur.bind(this) } onFocus={ this.handleFocus.bind(this) } placeholder={this.context.t("Please type at least 3 letters")} />
        </InputGroup>
        { faqSearchResultsOpen && 
          <ListGroup className="shadow-sm">
            { faqsearchresults.map((faq) => {
              return (
                <ListGroupItem action key={`faqautocomplete-${faq.id}`} className='text-left' tag="button" onClick={ this.handleFaqSearchClick.bind(this, faq) }>{faq.question}</ListGroupItem>
              )
            })}
            {faqsearchresults && faqsearchresults.length === 0 &&
               <ListGroupItem className="small text-remark">{this.context.t('Sorry, we did not find any entries in our database. Please try a different search.')}</ListGroupItem>
            }
          </ListGroup>
        }
      </>
    );
  }
}

/**  define proptype for the 'translation' function  */
FaqAutocompleteSearch.contextTypes = {
  t: PropTypes.func
}


/** export the redux connected component and add a frontload call */
export default connect(mapStateToProps, mapDispatchToProps)((FaqAutocompleteSearch));